export const VUEX_SUBHEADER_SHOW = 'VUEX_SUBHEADER_SHOW'
export const VUEX_SUBHEADER_HIDE = 'VUEX_SUBHEADER_HIDE'
export const VUEX_SUBHEADER_TOGGLE_OPEN_STATE = 'VUEX_SUBHEADER_TOGGLE_OPEN_STATE'
export const VUEX_SUBHEADER_SET_SIZE = 'VUEX_SUBHEADER_SET_SIZE'
export const VUEX_SUBHEADER_SET_CLOSE_BTN_VISIBLE = 'VUEX_SUBHEADER_SET_CLOSE_BTN_VISIBLE'
export const VUEX_SUBHEADER_UPDATE_CONTENT = 'VUEX_SUBHEADER_UPDATE_CONTENT'
export const VUEX_SUBHEADER_UPDATE_PROPS = 'VUEX_SUBHEADER_UPDATE_PROPS'
